import { render, staticRenderFns } from "./SitesSidebar.vue?vue&type=template&id=3097e3e2&"
import script from "./SitesSidebar.vue?vue&type=script&lang=js&"
export * from "./SitesSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports